<template>
    <v-row class="ma-0 pb-offset">
		<v-col class="pa-0">
            <v-card class="flex pa-0 background-2 round-card">
                <v-card-title class="pa-3">
				    <p class="pl-2 pl-xl-3">Notifiche</p>
                    <v-spacer></v-spacer>
                </v-card-title> 
                <v-divider></v-divider>
                <v-list two-line subheader class="background-2 pa-2">
                    <v-list-item>
                        <v-list-item-action>
                            <v-checkbox 
                                color="primary" 
                                hide-details
                                v-model="settings['notify_expiring_task']">
                            </v-checkbox>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Scadenza Task</v-list-item-title>
                            <v-list-item-subtitle>Ricevi una notifica quando un task sta per scadere
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>      

                <v-slide-y-transition>
                    <v-list two-line subheader class="background-2 px-2 pb-2 pt-0" v-if="settings['notify_expiring_task']">
                        <v-list-item>
                            <v-list-item-action>
                            </v-list-item-action>
                            <v-list-item-content style="height: 90px; padding-top: 24px;">
                                <v-text-field v-if="settings['notify_expiring_task']"
                                    label="Numero giorni prima"
                                    v-model="settings['notify_expiring_task_day_before']"
                                    type="number"
                                    required
                                    outlined
                                    dense
                                    :error-messages="errors.collect('daybefore1')"
                                    v-validate="'required'"
                                    data-vv-name="daybefore1"
                                    data-vv-as="Numero giorni prima"
                                ></v-text-field>   
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-slide-y-transition>

                <v-list two-line subheader class="background-2 pa-2">
                    <v-list-item>
                        <v-list-item-action>
                            <v-checkbox color="primary" v-model="settings['notify_expired_task']"></v-checkbox>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Task Scaduto</v-list-item-title>
                            <v-list-item-subtitle>Ricevi una notifica quando un task è scaduto
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>                
                </v-list>

                <v-list two-line subheader class="background-2 pa-2">
                    <v-list-item>
                        <v-list-item-action>
                            <v-checkbox color="primary" v-model="settings['products_association_task']"></v-checkbox>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Associazione Prodotti</v-list-item-title>
                            <v-list-item-subtitle>Permetti di aggiungere dei prodotti a un task
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>                
                </v-list>
                <v-list two-line subheader class="background-2 pa-2" v-if="settings['products_association_task']">
                    <v-list-item>
                        <v-list-item-action>
                            <v-checkbox color="primary" v-model="settings['product_task_movements']"></v-checkbox>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Movimentazioni Magazzino per prodotti inseriti nei Task</v-list-item-title>
                            <v-list-item-subtitle>Rendi attive le movimentazioni di magazzino di scarico per i prodotti inseriti nei Task
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>                
                </v-list>
                
                
                <v-list two-line subheader class="background-2 pa-2">
                    <v-list-item>
                        <v-list-item-action>
                            <v-checkbox color="primary" v-model="settings['hide_checklists_task']"></v-checkbox>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Nascondi Checklist</v-list-item-title>
                            <v-list-item-subtitle>Le checklist sui task saranno disabilitate
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>                
                </v-list>

                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text class="mx-4 my-0" color="primary" @click.native="saveSettings">Salva</v-btn>
                </v-card-actions>

            </v-card>
        </v-col>
    </v-row>
</template>

<script>
    import Vue from 'vue'
	import SettingsOptionsMixin from '@/mixins/SettingsOptionsMixin';

    export default {
        name: 'tasks-options',
		mixins: [SettingsOptionsMixin],
        props: {},
        data() {
            return {
                model: 'task',
                settings: {
                    'notify_expiring_task': false,
                    'notify_expiring_task_day_before': false,
                    'products_association_task': false,
                    'product_task_movements': false,
                    'hide_checklists_task': false,
                },
            }
        },

        watch: {
            settings: {
                handler() {
                    if(!this.settings['notify_expiring_task']) {
                        Vue.set(this.settings, 'notify_expiring_task_day_before', null)
                    }
                },
                deep: true,
            }
        },

    }
</script>

<style scoped>

</style>